import { render, staticRenderFns } from "./searchSidebar.vue?vue&type=template&id=19318bf1&scoped=true&"
import script from "./searchSidebar.vue?vue&type=script&lang=js&"
export * from "./searchSidebar.vue?vue&type=script&lang=js&"
import style0 from "./searchSidebar.vue?vue&type=style&index=0&id=19318bf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19318bf1",
  null
  
)

export default component.exports